import { render, staticRenderFns } from "./team.vue?vue&type=template&id=2915a644"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,Panel: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/panel/Panel.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
